import { ReactComponent as ArrowDown } from "assets/ArrowDown.svg";
import { ReactComponent as ArrowUp } from "assets/ArrowUp.svg";
import { ReactComponent as DeleteIcon } from "assets/DeleteIcon.svg";
import { ReactComponent as WarningCircle } from "assets/WarningCircle.svg";
import { default as CheckBox, default as Checkbox } from "components/common/Checkbox";
import { filterPage } from "components/common/Filters/FiltersHelper";
import { setPageFilter } from "components/common/Filters/GlobalFilters.slice";
import Typography from "components/common/Typography";
import { setSelectedSuggestedInncodes } from "components/features/ManageSuggestions/ManageSuggestions.slice";
import { cloneDeep } from "lodash";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { getNamesFromHtlId, noDataFound } from "utils/CommonFunctions";
import { getUIFormatDate } from "utils/DateHelper";
import { recommendationAccessTypes } from "utils/Types";
import "../../common/MobileTableForSCList.scss";
import "./MobileTableForManageSuggestion.scss";

const MobileCommonTableForManageSuggestion = (props: any) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const selectedSuggestedInncodes: any = useAppSelector((state) => state.manageSuggestions.selectedSuggestedInncodes);
  const uploadRecommendationAccess = useAppSelector(
    (state) => state.app.loggedInUserDetails.uploadRecommendationAccess
  );
  const suggestedByDetails = useAppSelector((state) => state.manageSuggestions.suggestedByDetails);

  const [isRowOpen, setIsRowOpen] = useState<any>([]);

  const openSelectedRow = (row: any, index: any, isRowExpanded: boolean) => {
    // Create a deep clone of the current `isRowOpen` state to avoid mutating state directly
    const clonedIsRowOpen = cloneDeep(isRowOpen);
    // Find if an entry with the given index already exists in the cloned state
    const item = clonedIsRowOpen?.find((item: any) => item.key === index);

    if (item) {
      // If found, toggle its `isOpen` state
      item.isOpen = !item.isOpen; // Mutating the object directly inside cloned array
    } else {
      // If not found, add a new entry with `isOpen` set to `true`
      clonedIsRowOpen.push({ key: index, isOpen: true });
    }

    // Update the state with the modified cloned array
    setIsRowOpen(clonedIsRowOpen);
    if (isRowExpanded) props.getInnerTableData(row);
    props.setId(row);
  };

  const renderRow = (history: any, row: any, historyIndex: number, index: number) => {
    const Icon = props.getIcon(history?.suggestedThrough);
    return (
      <div className="history-container">
        <div
          className={
            !history?.applicableForInnCode
              ? " grid-2fr-table history-wrapper not-applicable-bg"
              : "grid-2fr-table history-wrapper"
          }
        >
          <div className="header-value-wrapper">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              Priority
            </Typography>
          </div>
          <div className="header-value-wrapper">
            {" "}
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              {history?.priority || "-"}
            </Typography>
          </div>

          <div className="header-value-wrapper user-checkbox">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              Suggested plans
            </Typography>
          </div>
          <div className="header-value-wrapper">
            {!history?.applicableForInnCode && <WarningCircle />}
            <Typography
              variant="body2"
              color={tokens.Text.General.PrimaryBody}
              className={history.applicableForInnCode ? "text-underline" : ""}
              onClick={() => {
                if (history.applicableForInnCode) {
                  dispatch(
                    setPageFilter({
                      pageName: filterPage.planProgressFromLibraryDisplay,
                      modifiedFilter: [
                        {
                          id: 6,
                          key: "planSource",
                          options: [
                            "recommended_default",
                            "recommended_criteria",
                            "recommended_brand_deadline",
                            "recommended_initiative"
                          ],
                          name: "Plan Source"
                        }
                      ]
                    })
                  );
                  navigate(`/plandetails/${history?.cmsId}`, {
                    state: {
                      innCode: row?.inncode,
                      defaultTab: 1
                    }
                  });
                }
              }}
            >
              {history?.planName || "-"}
            </Typography>
          </div>

          <div className="header-value-wrapper">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              Suggested by
            </Typography>
          </div>
          <div className="header-value-wrapper">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              {getNamesFromHtlId([history?.suggestedBy], suggestedByDetails) || "-"}
            </Typography>
          </div>

          <div className="header-value-wrapper">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              Submission Type
            </Typography>
          </div>
          <div className="header-value-wrapper">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              {Icon && <Icon />} {history.suggestedThrough || "-"}
            </Typography>
          </div>

          <div className="header-value-wrapper">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              Expire date
            </Typography>
          </div>
          <div className="header-value-wrapper">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              {getUIFormatDate(history?.expiryDate) || "-"}
            </Typography>
          </div>

          <div className="header-value-wrapper">
            <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
              Delete
            </Typography>
          </div>
          <div className="header-value-wrapper">
            {history.suggestedThrough === "User Added" &&
            uploadRecommendationAccess === recommendationAccessTypes.upload ? (
              <div
                style={{ cursor: "pointer" }}
                onClick={() => {
                  props.setOpenDeleteDialog(history);
                }}
              >
                <DeleteIcon />
              </div>
            ) : (
              <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
                -
              </Typography>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="common-mobile-table mobile-table-manageSuggestion">
        {props?.data?.rows?.length ? (
          <div className="common-mobile-table-container ">
            <div className="content-wrapper bottom-border">
              <div className="content-header-container">
                <div className="icon-name-wrapper">
                  <div className="up-down-icon visibility-hidden">
                    <ArrowUp />
                  </div>
                  <div className="value-with-checkbox">
                    <CheckBox
                      disabled={props?.data?.view === "manageSuggestions" && props.totalRecords === 0}
                      onChange={props.handleSelectedAll}
                      checked={props.selectAllProperties}
                    />
                    <div className="ellipse-two">
                      <Typography color={tokens.Text.General.PrimaryHeadline} variant="body2">
                        Inncode
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {props?.data?.rows?.map((row: any, index: number) => {
              const isRowExpanded = isRowOpen?.find((item: any) => item.key === index)?.isOpen;

              return (
                <>
                  <div className={`content-wrapper ${isRowExpanded ? "section-heading-open" : ""} `}>
                    <div className="content-header-container">
                      <div className="icon-name-wrapper">
                        <div
                          className="up-down-icon"
                          onClick={() => {
                            if (row?.suggestedPlansCount > 0) openSelectedRow(row, index, !isRowExpanded);
                          }}
                        >
                          {isRowExpanded ? <ArrowUp /> : <ArrowDown />}
                        </div>
                        <div className="value-with-checkbox">
                          {(uploadRecommendationAccess === recommendationAccessTypes.edit ||
                            uploadRecommendationAccess === recommendationAccessTypes.upload) && (
                            <Checkbox
                              checked={selectedSuggestedInncodes?.some((el: any) => el === row.inncode)}
                              onChange={(e: any) => {
                                const isChecked = e.target.checked;
                                let payload = selectedSuggestedInncodes && [...selectedSuggestedInncodes];
                                if (isChecked) {
                                  payload.push(row.inncode);
                                } else if (!isChecked) {
                                  const newData = selectedSuggestedInncodes?.filter((el: any) => el !== row.inncode);
                                  payload = newData;
                                }

                                dispatch(setSelectedSuggestedInncodes(payload));
                              }}
                            />
                          )}
                          <div>
                            <Typography color={tokens.Text.General.PrimaryHeadline} showBold variant="body2">
                              {row?.inncode}
                            </Typography>
                          </div>
                        </div>
                      </div>
                      <div>
                        <Typography variant="body2" color={tokens.Text.General.PrimaryBody}>
                          {row?.suggestedPlansCount}
                        </Typography>
                      </div>
                    </div>
                  </div>
                  {isRowExpanded &&
                    row?.history?.map((history: any, historyIndex: any) => {
                      return <div>{renderRow(history, row, historyIndex, index)}</div>;
                    })}
                </>
              );
            })}
          </div>
        ) : (
          <div className="horizontal-center">{noDataFound(props?.data?.headers?.length, "No Results")}</div>
        )}
      </div>
    </>
  );
};

export default MobileCommonTableForManageSuggestion;
